import { Button, CircularProgress } from '@mui/material'
import { Download } from '@mui/icons-material'

interface ExportButtonProps {
  onClick: () => void
  loading?: boolean
  disabled?: boolean
  text?: string
  fullWidth?: boolean
}

function ExportButton({ 
  onClick, 
  loading = false, 
  disabled = false, 
  text = 'Export to CSV',
  fullWidth = false
}: ExportButtonProps) {
  return (
    <Button
      variant="contained"
      size="large"
      onClick={onClick}
      disabled={disabled || loading}
      startIcon={loading ? <CircularProgress size={20} color="inherit" /> : <Download />}
      fullWidth={fullWidth}
      sx={{ 
        py: 1.5,
        textTransform: 'none',
        fontWeight: 500
      }}
    >
      {loading ? 'Exporting...' : text}
    </Button>
  )
}

export default ExportButton